<template>
    <div class="page-footer">
        <div class="container">
            <div class="flex">
                <div class="about">
                    <span>关注我们</span>
                    <div class="links">
                        <ul>
                            <li class="first">
                                <a href="javascript:void(0)" class="icon icon-06">
                                    <img src="../assets/images/index/weixincord.png">
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" class="icon icon-05">
                                    <img src="../assets/images/index/huaweicord.png">
                                </a>
                            </li>
                            <li><a href="https://weibo.com/hwenterprise?is_hot=1" target="_blank" class="icon icon-07"></a></li>
                            <!--<li><a href="https://www.linkedin.com/showcase/huawei-enterprise" target="_blank" class="icon icon-08"></a></li>-->
                        </ul>
                        <!--<a href="https://www.toutiao.com/c/user/74089686926/#mid=1582935816546318" target="_blank" class="app"></a>-->
                        <!--<a href="" target="_blank" class="wx"></a>-->
                        <!--<a href="https://weibo.com/huaweiweibo" target="_blank" class="wb"></a>-->
                        <!--<a href="https://www.linkedin.com/company/huawei" target="_blank" class="li"></a>-->
                        <!--<a href="https://www.zhihu.com/org/hua-wei-62-16" target="_blank" class="zh"></a>-->
                    </div>
                </div>
                <div class="ct">
                    <p><a href="https://www.huawei.com/cn/contact-us" target="_blank">联系我们</a> | <a href="https://www.huawei.com/cn/legal" target="_blank">法律声明</a> | <a href="https://www.huawei.com/cn/privacy-policy" target="_blank">隐私保护</a></p>
                    <p>版权所有 © 华为技术有限公司 1998-2020</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "response-footer"
  };
</script>

<style lang="scss" scoped>
    .page-footer{
        width: 100%;
        height: auto;
        background-color: #e8e9ee;
        .flex{
            width: 100%;
            font-size: 12px;
            padding: 0;
            .about {
                flex: 0 0 50%;
                color: #4a4a4a;
                text-align: left;
                display: flex;
                align-items: center;
                span {
                    display: inline-block;
                    font-size: 12px;
                }
                .links {
                    display: inline-block;
                    height: 50px;
                    vertical-align: top;
                    margin: 0 0 0 10px;
                    a {
                        display: block;
                        width: 24px;
                        height: 24px;
                        float: left;
                        margin: 13px 5px;
                        border: 1px solid #555;
                        border-radius: 5px;
                        background-size: 100% 100%;
                        &.wb {
                            background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/weibo.png");
                        }
                        &.li {
                            background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/linkin.png");
                        }
                        &.wx {
                            background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/weixin.png");
                        }
                        &.tt {
                            background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/toutiao.png");
                        }
                        &.zh {
                            background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/zhihu.png");
                        }
                        &.app {
                            background-image: url("../assets/images/icon/app-icon.png");
                            -webkit-background-size: contain;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center center;
                        }
                    }
                    ul {
                        font-size: 0;

                        li {
                            display: inline-block;
                            text-align: center;
                            a {
                                display: block;
                                width: 24px;
                                height: 24px;
                                float: left;
                                margin: 13px 5px;
                                border: 1px solid #555;
                                border-radius: 5px;
                                background-size: contain;
                                position: relative;
                                img {
                                    display: none;
                                    position: absolute;
                                    transition: all 0.3s;
                                    width: 70px;
                                }
                                &.icon-05 {
                                    background-image: url("../assets/images/icon/app-icon.png");
                                    background-position: center center;
                                    background-repeat: no-repeat;

                                    &:hover {
                                        img {
                                            display: block;
                                            /*top: -118px;
                                            left: -42px;*/
                                            top: -80px;
                                            left: -24px;
                                        }

                                    }
                                }
                                &.icon-06 {
                                    background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/weixin.png");

                                    &:hover {
                                        img {
                                            display: block;
                                            top: -80px;
                                            left: -24px;
                                        }

                                    }
                                }

                                &.icon-07 {
                                    background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/weibo.png");
                                }

                                &.icon-08 {
                                    background-image: url("//www.huawei.com/~/media/CORPORATE/minisite/hc2019/v2/img/icon/linkin.png");
                                }
                            }
                        }
                    }
                }
            }
            .ct {
                flex: 0 0 50%;
                text-align: right;
                padding-top: 8px;
                p {
                    color: #a4a4a7;
                    font-size: 12px;
                    line-height: 20px;
                    margin: 0;
                    a{
                        color: #666;
                    }
                }
            }
        }
    }
@media (max-width: 750px) {
    .page-footer{
        .flex{
            position: relative;
            width: 100%;
            height: 2.76rem;
            background: #eaebf0;
            padding: 13px 0;
            text-align: center;
            z-index: 4;
            display: block;
            .about {
                display: block;
                text-align: center;
                margin-top: 0.35rem;
                span {
                    display: block;
                    font-size: 0.28rem;
                    color: #555;
                    line-height: 22px;
                }
                .links {
                    margin: 0.22rem 0;
                    text-align: center;
                    height: auto;
                    a {
                        display: inline-block;
                        height: 0.6rem;
                        width: 0.6rem;
                        background-size: 100% 100%;
                        vertical-align: top;
                        margin: 0 5px;
                        border: 1px solid #555;
                        border-radius: 3px;
                    }
                    ul {
                        li {
                            a {
                                margin: 0 5px;
                            }
                        }
                    }
                }
            }
            .ct {
                margin-top: 0px;
                text-align: center;
                top: 0;
                padding-top: 0;
                p {
                    color: #a4a4a7;
                    font-size: 0.24rem;
                    line-height: 0.36rem;
                    a{
                        color: #666;
                    }
                }
            }
        }
    }
}
</style>
